import React from 'react';
import { Redirect } from 'react-router';
import { getVenues_user_venues } from './__queries__';
import { useLogger } from '~Hooks';

interface Props {
  venue: getVenues_user_venues | undefined;
}

/** A user only ever has access to a single venue, so we always forward to it. */
const AutoForwarder: React.FunctionComponent<Props> = ({ venue }) => {
  const logger = useLogger('venues-selection');

  if (!venue) {
    return null;
  }

  logger.info(`Auto-forwarding to the only venue available: ${venue.id}`);
  return <Redirect to={`venue/${venue.id}/gateway`} />;
};

export default AutoForwarder;
